<div class="title">
    <h2 mat-dialog-title>{{data.title}}</h2>
</div>
<mat-dialog-content>
    <p>{{data.message}}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button *ngFor="let action of data.actions" mat-button (click)="excecuteAction(action)">
        {{action.label}}
    </button>
</mat-dialog-actions>